import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { config } from './config';
import { installSessionPorts } from './session';
import './app.css';

// Validated here rather than where it is read (P0-WEB-04). A missing
// VITE_API_URL is inlined by Vite as `undefined`, so the first symptom would
// otherwise be a request to `undefined/v1/health` failing CORS — a message that
// names neither the variable nor the file to put it in.
config();

// Binds the two ports P0-WEB-04 left unbound: the organisation header on every
// request, and what happens on a 401. Explicit rather than an import-time side
// effect — wiring that runs before the app has decided anything is invisible at
// exactly the point somebody needs to find it.
installSessionPorts();

// P0-INF-11 installs a Sentry-backed reporter here:
//   import { setErrorReporter } from './observability/error-reporter';
//   setErrorReporter(sentryReporter);
// Nothing else changes — the boundaries already report through the port.

const container = document.getElementById('root');

if (container === null) {
  // Not defensive padding: if index.html ever loses the mount node, this says
  // so instead of rendering a blank page with a silent null in the console.
  throw new Error('Root container #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
